import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { BoardContext } from "../../../context";
import { ArrowButton } from "../../atoms";

interface IStrengthCardsToggleArrow {
    zIndexPerPhase: number
}

const StrengthCardsToggleArrow: FC<IStrengthCardsToggleArrow> = ({ zIndexPerPhase }) => {
    const { isStrengthCardsComponentShown, setIsStrengthCardsComponentShown } = useContext(BoardContext);
    const { t } = useTranslation();

    const getStyleForArrowPosition = () => {
        if(isStrengthCardsComponentShown)
            return "arrow_position_when_strengths_are_shown";

        if(!isStrengthCardsComponentShown)
            return "arrow_position_when_strengths_are_not_shown";
    }

    return(
      <div className={getStyleForArrowPosition()} style={{zIndex: zIndexPerPhase}} > 
          <ArrowButton
                    arrowVwHeight={5}
    				arrowVwWidth={5}
                    arrowDirection="horizontal"
                    toolTipText={t("strengthCardsText")}
                    tipSide="right"
                    clickHandler={() => setIsStrengthCardsComponentShown(!isStrengthCardsComponentShown) }
                    isTheDivShown={isStrengthCardsComponentShown}
                    disabled={false}
                />
      </div>  
      );
}

export default StrengthCardsToggleArrow;